import type { ReactNode, FC } from 'react';
import { Children } from 'react';
import { useCarousel } from 'src/common/providers/CarouselProvider';
import styles from './Carousel.module.scss';

export type CarouselProps = {
  children: ReactNode;
};
/**
 * This `Carousel` manages scrollable grid layout only.
 * It is a companion to `CarouselButtons`, which uses embla methods like `scrollNext()`.
 * Wrap both in a CarouselProvider and then position each independently.
 */
const Carousel: FC<CarouselProps> = ({ children }) => {
  const { emblaRef } = useCarousel();

  return (
    <div className={styles.container}>
      <div
        className={styles.viewport}
        ref={emblaRef}
      >
        <ul
          className={styles.list}
        >
          {Children.map(children, (child) => {
            if (child) {
              return (
                <li>
                  {child}
                </li>
              );
            }
            return null;
          })}
        </ul>
      </div>
    </div>
  );
};

export default Carousel;
